<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <!-- <div
        v-bind="attrs"
        v-on="on"
        :class="['body-2 px-2 mr-1 white--text', value ? 'green' : 'red']"
      >
        {{ text }}
      </div> -->
      <v-chip
        :color="value ? 'success' : 'red white--text'"
        small
        label
        v-bind="attrs"
        v-on="on"
        class="mx-1"
        >{{ text }}</v-chip
      >
    </template>

    <span>{{ description }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "CustomTooltip",
  props: ["text", "value", "description"]
};
</script>
